import { useState } from "react";

import { makeStyles, Typography, Collapse } from "@material-ui/core";

import { CarbonRevenueTab } from "./tabs/carbonRevenues";
import { EmissionImpactIntelligenceTab } from "./tabs/emissionImpactIntelligence";
import { EmissionRegulationTab } from "./tabs/emissionRegulation";
import { InspiringClimateProjectsTab } from "./tabs/inspiringClimateProjects";
import { SaveThePlanetTab } from "./tabs/saveThePlanet";
import { HorizontalTabs } from "../../components/horizontalTabs";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: `${theme.spacing(2.5)}px ${theme.spacing(4)}px`,
    height: "100%",
    boxSizing: "border-box",
  },
  title: {
    marginBottom: theme.spacing(1.6),
    fontWeight: 400,
  },
}));

export const CarbonImpactPage = () => {
  const classes = useStyles();
  const [tab, setTab] = useState(0);

  const getActiveTabComponent = () => {
    switch (tab) {
      case 0:
        return (
          <Collapse in={tab === 0}>
            <SaveThePlanetTab />
          </Collapse>
        );
      case 1:
        return (
          <Collapse in={tab === 1}>
            <CarbonRevenueTab />
          </Collapse>
        );
      case 2:
        return (
          <Collapse in={tab === 2}>
            <InspiringClimateProjectsTab />
          </Collapse>
        );
      case 3:
        return (
          <Collapse in={tab === 3}>
            <EmissionRegulationTab />
          </Collapse>
        );
      case 4:
        return (
          <Collapse in={tab === 4}>
            <EmissionImpactIntelligenceTab />
          </Collapse>
        );
      default:
        return (
          <Collapse in={tab === 0}>
            <SaveThePlanetTab />
          </Collapse>
        );
    }
  };

  return (
    <div className={classes.root}>
      <Typography className={classes.title} variant="h2">
        Emission Impact
      </Typography>

      <HorizontalTabs
        tab={tab}
        setTab={setTab}
        tabNames={[
          "Save the Planet",
          "Carbon Revenues",
          // "Inspiring Climate Projects",
          // "Emission Regulation",
          // "Emission Impact Intelligence",
        ]}
      />

      {getActiveTabComponent()}
    </div>
  );
};
